export const line = {
  visible: true,
  active: false,
  handles: {
    start: {
      x: 0,
      y: 0,
      highlight: true,
      active: false
    },
    end: {
      x: 0,
      y: 0,
      highlight: true,
      active: false
    },
    textBox: {}
  },
  length: 0,
  invalidated: true
};
